import type { BooleanFilterViewState } from '../../../common/constants/filters/boolean-filter/types';
import { useBooleanFilterStore } from '../../store/search';
import { getProductToSelect } from '../utils';

export const useBooleanFilter: ({ filterId }: { filterId: string }) =>
	| [
			undefined,
			{
				toggle: () => void;
			},
	  ]
	| [
			{
				value: boolean;
				autoFocus: boolean;
			},
			{
				toggle: () => void;
			},
	  ] = ({ filterId }: { filterId: string }) => {
	const [state, storeActions] = useBooleanFilterStore({
		filterId,
	});

	const viewActions = {
		toggle: () => {
			if (!state) {
				return;
			}

			const productToSelect = getProductToSelect({
				isUniversal: state?.universal,
				primaryProduct: state?.primaryProduct ?? undefined,
				selectedProduct: state?.selectedProducts[0],
			});

			storeActions.setBooleanFilterValue({
				filterId,
				value: !state.value,
				options: { setSelectedProduct: productToSelect },
			});
		},
	};

	if (!state) {
		return [, viewActions] satisfies [BooleanFilterViewState | undefined, typeof viewActions];
	}

	const viewState = {
		value: state.value,
		autoFocus: state.alwaysVisible === false,
	} satisfies BooleanFilterViewState;

	return [viewState, viewActions] satisfies [BooleanFilterViewState, typeof viewActions];
};
